import { render, staticRenderFns } from "./button-tab.vue?vue&type=template&id=d4a7f6f4&"
import script from "./button-tab.vue?vue&type=script&lang=js&"
export * from "./button-tab.vue?vue&type=script&lang=js&"
import style0 from "./button-tab.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports